import React, { useState, useEffect } from "react";
// import { useOktaAuth, LoginCallback } from "@okta/okta-react";
import { useAuth0, Auth0Provider } from "@auth0/auth0-react";
// import { OktaAuth } from "@okta/okta-auth-js";
import { login } from "../../services/api";
import { saveTokenToTelescope } from "../../services/api"
import "./LoginForm.css";
import { useNavigate } from "react-router-dom";

// Auth0 Configuration
const domain = "dev-azrdlalkmejv15a6.us.auth0.com";
const clientId = "zbkatwLIPYhVdQYpayNnAxIpy4iFQ276";

const LoginFormContent: React.FC = () => {
  const { loginWithRedirect, isAuthenticated, logout, user, getAccessTokenSilently } = useAuth0();
  const [loginMessage, setLoginMessage] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    const sendTokenToBackend = async () => {
      const storedTokenSent = localStorage.getItem("tokenSent");
      if (isAuthenticated && storedTokenSent !== "true") {
        try {
          const token = await getAccessTokenSilently(); // Get Auth0 token
          const user_email = user?.email

          const response = await saveTokenToTelescope(
            token,
            user_email
          );

          console.log("Backend Response:", response.data);
          localStorage.setItem("tokenSent", "true");
          setLoginMessage("Successfully authenticated!");

        } catch (error) {
          console.error("Error sending token to backend:", error);
          setLoginMessage("Error verifying login with backend.");
        }
      }
    };

    sendTokenToBackend();
  }, [isAuthenticated]); // Runs when the user logs in


  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      await loginWithRedirect();

    } catch (error) {
      setLoginMessage("Login failed. Please try again.");
    }
  };

  return (
    <div className="form-container">
      <h2 className="welcome-text">Welcome back</h2>
      <p className="details-text">Please enter your details</p>

      {!isAuthenticated ? (
        <form onSubmit={handleLogin}>
          {loginMessage && (
            <p
              className={
                loginMessage.includes("success")
                  ? "login-message success"
                  : "login-message error"
              }
            >
              {loginMessage}
            </p>
          )}
          <button type="submit" className="sign-in-btn">
            Sign in with Auth0
          </button>
        </form>
      ) : (
        <div>
          <p className="login-message success bold" style={{color: 'green'}}>Successfully Logged In as {user?.email}</p>          
          <button onClick={() => logout({ logoutParams: { returnTo: window.location.origin } })} className="sign-in-btn">
            Log Out
          </button>
        </div>
      )}
    </div>
  );
};

const LoginForm: React.FC = () => (
  <Auth0Provider
    domain={domain}
    clientId={clientId}
    authorizationParams={{
      redirect_uri: window.location.origin,
    }}
  >
    <LoginFormContent />
  </Auth0Provider>
);

export default LoginForm;



// const LoginForm: React.FC = () => {
//   const [email, setEmail] = useState("");
//   const [password, setPassword] = useState("");
//   const [loginMessage, setLoginMessage] = useState("");
//   // const { authState } = useOktaAuth();
//   const navigate = useNavigate();

//   const handleEmailChange = (e: React.ChangeEvent<HTMLInputElement>) => {
//     setEmail(e.target.value);
//     setLoginMessage("");
//   };

//   const handlePasswordChange = (e: React.ChangeEvent<HTMLInputElement>) => {
//     setPassword(e.target.value);
//     setLoginMessage("");
//   };

//   const handleLogin = async (e: React.FormEvent) => {
//     e.preventDefault();
//     try {
//       // Call the login API
//       //const response = await login(email, password);
      
//       // await oktaAuth.signInWithRedirect({
//       //   originalUri: window.location.href,
//       //   idp: "{google_idp_id}", // Replace with Google Identity Provider ID from OKTA
//       // });
//       debugger
//       const { loginWithRedirect } = useAuth0();
//       loginWithRedirect();

//       // await oktaAuth.signInWithRedirect({
//       //   originalUri: "/", // Redirect back to the login page
//       // });

//       // if (response.status.code === 200) {
//       //   navigate("/dashboard");
//       // }
//     } catch (error) {
//       setLoginMessage("Invalid Email or Password");
//     }
//   };

//   const isCallback = window.location.pathname === "/login/callback";

//   // useEffect(() => {
//   //   if (authState?.isAuthenticated) {
//   //     setLoginMessage("✅ You are successfully logged in!");
//   //   }
//   // }, [authState]);

//   if (isCallback) {
//     return <LoginCallback />; // Handle the OAuth callback response
//   }

//   const checkAuthStatus = async () => {
//     const tokens = await oktaAuth.token.parseFromUrl();
//     if (tokens) {
//       setLoginMessage("✅ User successfully logged in!");
//     }
//   };

//   return (
//     <div className="form-container">
//       <h2 className="welcome-text">Welcome back</h2>
//       <p className="details-text">Please enter your details</p>
//       <form onSubmit={handleLogin}>
//         <label className="input-label">Email Address</label>
//         <input
//           type="email"
//           placeholder="Email Address"
//           className="input"
//           value={email}
//           onChange={handleEmailChange}
//         />

//         <label className="input-label">Password</label>
//         <input
//           type="password"
//           placeholder="Password"
//           className="input"
//           value={password}
//           onChange={handlePasswordChange}
//         />
//         {!loginMessage.includes("success") ? (
//           <p
//             className={
//               loginMessage.includes("success")
//                 ? "login-message success"
//                 : "login-message error"
//             }
//           >
//             {loginMessage}
//           </p>
//         ) : null}
//         {/* Remember me and Forgot Password container */}
//         <div className="remember-forgot-container">
//           <label className="remember-me">
//             <input type="checkbox" /> Remember for 30 days
//           </label>
//           <a href="#" className="forgot-password">
//             Forgot Password
//           </a>
//         </div>

//         <button type="submit" className="sign-in-btn">
//           Sign in
//         </button>
//       </form>

//       <p className="sign-up-option">
//         Don’t have an account? <a href="#">Sign up</a>
//       </p>
//       {loginMessage && (
//         <p
//           className={
//             loginMessage.includes("success")
//               ? "login-message success"
//               : "login-message error"
//           }
//         >
//           {loginMessage}
//         </p>
//       )}
//     </div>
//   );
// };

// export default LoginForm;


